export default "__VITE_ASSET__B98xn8_S__"